import AbstractApi from "../AbstractApi";

class FilesApi extends AbstractApi  {

  // Files
  indexMethod = 'dashboard/sites_catalogues/{:id}/files/index';
  htaccessMethod = 'dashboard/sites_catalogues/{:id}/files/htaccess';


  /*--------------------------------------------------------------------------*/
  /* Files */

  async index(id) {

    this.requestMethod = this.indexMethod.replace('{:id}', id);

    this.requestData = new FormData();
    this.requestData.append('token', this.authToken);

    return await this.request();
  }


  async htaccess(id) {

    this.requestMethod = this.htaccessMethod.replace('{:id}', id);

    this.requestData = new FormData();
    this.requestData.append('token', this.authToken);

    return await this.request();
  }

}

export default FilesApi;
